module.exports = __webpack_public_path__ + "img/dg_k.a1d31919.png";